import React, { useState } from 'react';
import FacebookLogin from '@greatsumini/react-facebook-login';
import { Button } from 'antd';
import { FacebookFilled } from '@ant-design/icons';
import authService from '../../services/authService';

const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID || '';

interface FacebookSignInButtonProps {
  onSuccess: () => void;
  onError?: (message: string) => void;
}

// Exchanges a Facebook access token for the backend JWT and starts the app session
export function FacebookSignInButton({ onSuccess, onError }: FacebookSignInButtonProps) {
  const [loading, setLoading] = useState(false);

  return (
    <FacebookLogin
      appId={FACEBOOK_APP_ID}
      scope="public_profile"
      onSuccess={async (response) => {
        if (!response.accessToken) {
          onError?.('Facebook access token авахад алдаа гарлаа');
          return;
        }
        setLoading(true);
        try {
          await authService.loginWithFacebook(response.accessToken);
          onSuccess();
        } catch (error: any) {
          onError?.(error.message || 'Facebook нэвтрэхэд алдаа гарлаа');
        } finally {
          setLoading(false);
        }
      }}
      onFail={() => {
        onError?.('Facebook нэвтрэхэд алдаа гарлаа');
      }}
      render={({ onClick }) => (
        <Button
          size="large"
          loading={loading}
          onClick={onClick}
          icon={<FacebookFilled style={{ fontSize: '20px' }} />}
          style={{
            width: '100%',
            height: '48px',
            borderRadius: '8px',
            background: '#1877F2',
            border: '1px solid #1877F2',
            color: 'white',
            fontWeight: 500,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
          }}
        >
          Facebook-ээр нэвтрэх
        </Button>
      )}
    />
  );
}

interface LinkFacebookButtonProps {
  onLinked: () => void;
  onError?: (message: string) => void;
}

// Links a Facebook account to the currently authenticated user; requires a backend JWT
export function LinkFacebookButton({ onLinked, onError }: LinkFacebookButtonProps) {
  const [loading, setLoading] = useState(false);

  return (
    <FacebookLogin
      appId={FACEBOOK_APP_ID}
      scope="public_profile"
      onSuccess={async (response) => {
        if (!response.accessToken) {
          onError?.('Facebook access token авахад алдаа гарлаа');
          return;
        }
        setLoading(true);
        try {
          await authService.linkFacebook(response.accessToken);
          onLinked();
        } catch (error: any) {
          onError?.(error.message || 'Facebook холбоход алдаа гарлаа');
        } finally {
          setLoading(false);
        }
      }}
      onFail={() => {
        onError?.('Facebook холбоход алдаа гарлаа');
      }}
      render={({ onClick }) => (
        <Button
          type="default"
          loading={loading}
          onClick={onClick}
          style={{
            borderRadius: '8px',
            height: '44px',
            padding: '0 24px',
            fontSize: '14px',
            fontWeight: '500',
            background: '#1877F2',
            border: '1px solid #1877F2',
            color: 'white',
          }}
        >
          Facebook холбох
        </Button>
      )}
    />
  );
}
